'use strict'
var refractorJsx = require('./jsx.js')
var refractorTypescript = require('./typescript.js')
module.exports = tsx
tsx.displayName = 'tsx'
tsx.aliases = []
function tsx(Prism) {
  Prism.register(refractorJsx)
  Prism.register(refractorTypescript)
  var typescript = Prism.util.clone(Prism.languages.typescript)
  Prism.languages.tsx = Prism.languages.extend('jsx', typescript)
}



//////////////////
// WEBPACK FOOTER
// ./~/refractor/lang/tsx.js
// module id = 390
// module chunks = 29546219236060 61549186969478 213534597649335